import React, { useMemo } from 'react'
import { Box } from '@chakra-ui/react'

import {
  Radar,
  RadarChart,
  Tooltip,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  ResponsiveContainer
} from 'recharts'

export const DimensionScoreChart = ({ dimensionScores = [], loading }) => {
  const data = useMemo(
    () =>
      dimensionScores
        .map(({ dimension, score }) => ({
          dimension: dimension.name,
          scale: dimension.scale,
          score: (score * 100).toFixed()
        }))
        .sort((a, b) => a.scale - b.scale),
    [dimensionScores]
  )

  return (
    <Box height='250px'>
      <ResponsiveContainer>
        <RadarChart outerRadius={80} data={data}>
          <Tooltip />
          <PolarGrid />
          <PolarAngleAxis tick={{ fontSize: 12 }} dataKey='dimension' />
          <PolarRadiusAxis angle={45} domain={[0, 100]} />
          <Radar name='Score' dataKey='score' stroke='#8884d8' fill='#8884d8' fillOpacity={0.6} />
        </RadarChart>
      </ResponsiveContainer>
    </Box>
  )
}

export default DimensionScoreChart
